module["exports"] = [
  "연구소",
  "게임즈",
  "그룹",
  "전자",
  "물산",
  "코리아"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/company/suffix.js
// module id = 1348
// module chunks = 0